import DataCheck from 'lib/src/components/common/DataCheck';
import Table from 'lib/src/components/table/Table';
import { Column } from 'lib/src/types/table';
import { getColor } from 'lib/src/utils/generic';
import { AssessmentScoreResponse } from 'src/types/shared/Assessments';
import useFetchSubmissionScores from './hooks/useFetchSubmissionScores';
import dayjs from 'dayjs';
import { useState } from 'react';
import DeleteAssessmentModal from './DeleteAssessmentModal';
import ActionButton from 'lib/src/components/button/ActionButton';
import ButtonRow from 'lib/src/components/button/ButtonRow';

interface Props {
    applicationID: number;
}

const SubmissionsScoresTable = ({ applicationID }: Props) => {
    const { scores, isFetching, fetchError } = useFetchSubmissionScores(applicationID);
    const [scoreToDelete, setScoreToDelete] = useState<AssessmentScoreResponse | null>(null);

    const columns: Column<ScoreRow>[] = [
        {
            key: 0,
            heading: 'Assessor Name',
            getValue: row => `${row.assessor.firstName} ${row.assessor.lastName}`,
            searchable: true,
        },
        {
            key: 1,
            heading: 'Assessor Email',
            getValue: row => row.assessor.email ?? '',
            searchable: true,
        },
        {
            key: 2,
            heading: 'CreatedOn',
            getValue: row =>
                row.assessment.createdOn
                    ? dayjs(row.assessment.createdOn).format('DD/MM/YYYY')
                    : '',
            searchable: true,
        },
        {
            key: 4,
            heading: 'Score',
            getValue: row => (
                <span className={getColor(row.score.total / 5)}>
                    {`${row.score.total + ' pts'}` || '-'}
                </span>
            ),
        },
        {
            key: 3,
            heading: '',
            getValue: row => (
                <ButtonRow>
                    <ActionButton color="red" icon="times" onClick={() => setScoreToDelete(row)}>
                        Remove
                    </ActionButton>
                </ButtonRow>
            ),
        },
    ];

    return (
        <>
            <DataCheck dataExists={scores.length > 0} isFetching={isFetching} error={fetchError}>
                <Table
                    columns={columns}
                    rows={scores.map(score => ({ id: score.assessment.id, ...score }))}
                />
            </DataCheck>

            {!!scoreToDelete && (
                <DeleteAssessmentModal
                    score={scoreToDelete}
                    hideModal={() => {
                        setScoreToDelete(null);
                    }}
                />
            )}
        </>
    );
};

interface ScoreRow extends AssessmentScoreResponse {
    id: number;
}

export default SubmissionsScoresTable;
